import { Fragment } from 'react'

import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'

import { formatter } from 'common/date'
import { User } from 'store/user'

import ActionsCell from './ActionsCell'
import ActiveCell from './ActiveCell'

interface GetColumnsParams {
  isUserPermitted: boolean
  onEdit: (record: User, isReviewingNewUser: boolean) => void
  onDelete: (record: User) => void
  onRolesEdit: (record: User) => void
}

const getColumns = ({ isUserPermitted, onEdit, onDelete, onRolesEdit }: GetColumnsParams): GridColDef[] => [
  {
    field: 'LastName',
    headerName: 'Last',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => params.row.LastName,
  },
  {
    field: 'FirstName',
    headerName: 'First',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => params.row.FirstName,
  },
  {
    field: 'Title',
    headerName: 'Title',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => params.row.Title,
  },
  {
    field: 'Active',
    headerName: 'Status',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => <ActiveCell record={params.row} />,
  },
  {
    field: 'LastLoginTime',
    headerName: 'Last Login',
    flex: 1,
    renderCell: (params: GridRenderCellParams) =>
      formatter.format(params.row.LastLoginTime, { outputFormat: 'MMM DD, YYYY h:mm:ss a' }) || (
        <Fragment>&mdash;</Fragment>
      ),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    flex: 2,
    minWidth: 280,
    renderCell: (params: GridRenderCellParams) => (
      <div onClick={(e) => e.stopPropagation()}>
        <ActionsCell
          record={params.row}
          isUserPermitted={isUserPermitted}
          onEdit={onEdit}
          onDelete={onDelete}
          onRolesEdit={onRolesEdit}
        />
      </div>
    ),
  },
]

export default getColumns
